export const enum PlaidErrorCode {
  MFA_NOT_SUPPORTED = 'MFA_NOT_SUPPORTED',
}
